import { Button, Popconfirm, Upload } from "antd";
import {
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showAppError } from "../utils/errorHandler";
import {
  DEFAULT_IMAGE_EXTENSIONS,
  getAttachmentAccept,
  isAttachmentExtensionAllowed,
} from "../utils/attachmentPayload";

const ImageUpload = ({
  name,
  image,
  callbackSetImageFile,
  allowedExtensions = DEFAULT_IMAGE_EXTENSIONS,
  fileTypeErrorKey = "validate_image_file_type",
}) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (typeof image === "string" && image) {
      setImageUrl(image);
    } else if (!image) {
      setImageUrl("");
    }
  }, [image]);

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const beforeUpload = (file) => {
    const isAllowedType = isAttachmentExtensionAllowed(
      file.name,
      allowedExtensions,
    );
    if (!isAllowedType) {
      showAppError(t(fileTypeErrorKey));
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      showAppError(t("validate_image_size"));
    }
    return isAllowedType && isLt2M;
  };

  const handleChange = (info) => {
    // Get this url from response in real world.
    getBase64(info.file.originFileObj, (imageUrl) => {
      setImageUrl(imageUrl);
      setLoading(false);
    });
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div className="app-mt-8">{t("upload")}</div>
    </div>
  );

  return (
    <div className="app-relative">
      <Upload
        name={name}
        listType="picture-card"
        accept={getAttachmentAccept(allowedExtensions)}
        className="avatar-uploader"
        showUploadList={false}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        customRequest={(data) => {
          callbackSetImageFile(data.file);
        }}
      >
        {imageUrl ? (
          <>
            <img
              src={imageUrl}
              alt={name}
              style={{ width: "100%", height: "100%" }}
            />
          </>
        ) : (
          uploadButton
        )}
      </Upload>
      {imageUrl ? (
        <Popconfirm
          title={t("warning_delete")}
          onConfirm={() => {
            setImageUrl("");
            callbackSetImageFile(null);
          }}
          okText={t("yes")}
          cancelText={t("no")}
          placement="topLeft"
        >
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            style={{
              padding: 0,
              zIndex: 2,
              position: "absolute",
              top: 0,
              left: 0,
            }}
          />
        </Popconfirm>
      ) : (
        ""
      )}
    </div>
  );
};

export default ImageUpload;
